import { motion } from "framer-motion";
import { PACKAGES, WHATSAPP_URL, WhatsAppIcon } from "@/lib/site";

export const Pricing = () => (
    <section id="prezzi" className="scroll-mt-20 border-b-2 border-ink bg-white">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-24">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5 }}
                className="max-w-3xl"
            >
                <p className="mb-4 inline-block border-2 border-ink bg-cream px-3 py-1 text-xs font-bold uppercase tracking-widest">
                    Listino chiaro
                </p>
                <h2 className="headline-display text-4xl font-bold sm:text-5xl">
                    I trattamenti e i prezzi
                </h2>
                <p className="mt-6 text-base font-medium leading-relaxed text-ink/80 md:text-lg">
                    Tre livelli di intervento in base al grado di opacità, più
                    una protezione d'élite opzionale. Il pacchetto adatto viene
                    confermato dopo la valutazione delle foto: il preventivo è
                    gratuito.
                </p>
                <p className="mt-4 text-base font-medium leading-relaxed text-ink/80 md:text-lg">
                    Ogni trattamento si conclude con la protezione
                    nanotecnologica, che mantiene il risultato nel tempo. Il
                    listino è pubblico e definito prima dell'appuntamento:
                    sai sempre in anticipo cosa faremo e quanto costa.
                </p>
            </motion.div>

            <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
                {PACKAGES.map((p, i) => (
                    <motion.article
                        key={p.id}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.5, delay: i * 0.08 }}
                        data-testid={`pricing-card-${p.id}`}
                        className={`flex h-full flex-col border-2 p-6 transition-[transform,box-shadow] duration-150 hover:-translate-y-1 hover:shadow-print ${
                            p.highlight
                                ? "border-royal bg-royal text-white"
                                : "border-ink bg-cream"
                        }`}
                    >
                        <div className="flex items-start justify-between gap-2">
                            <h3 className="font-display text-2xl font-bold uppercase tracking-tight">
                                {p.name}
                            </h3>
                            <span
                                className={`border-2 px-2 py-1 font-display text-xl font-bold ${
                                    p.highlight
                                        ? "border-white bg-white text-royal"
                                        : "border-ink bg-ink text-cream"
                                }`}
                            >
                                {p.price}
                            </span>
                        </div>
                        <p
                            className={`mt-1 text-xs font-bold uppercase tracking-widest ${
                                p.highlight ? "text-white/85" : "text-royal"
                            }`}
                        >
                            {p.condition}
                        </p>
                        <ul className="mt-4 flex-1 space-y-2">
                            {p.features.map((f) => (
                                <li
                                    key={f}
                                    className={`flex gap-2 text-sm font-medium leading-snug ${
                                        p.highlight ? "text-white/90" : "text-ink/80"
                                    }`}
                                >
                                    <span aria-hidden="true">▪</span>
                                    {f}
                                </li>
                            ))}
                        </ul>
                        <p
                            className={`mt-4 border-t-2 pt-3 text-xs font-bold uppercase tracking-wider ${
                                p.highlight
                                    ? "border-white/40 text-white"
                                    : "border-ink/20 text-ink/70"
                            }`}
                        >
                            {p.note}
                        </p>
                    </motion.article>
                ))}
            </div>

            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: 0.15 }}
                className="mt-10"
            >
                <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="pricing-whatsapp-btn"
                    className="inline-flex items-center gap-2 border-2 border-ink bg-wa px-6 py-3 font-display text-lg font-semibold uppercase tracking-tight text-ink transition-[transform,box-shadow] duration-150 hover:-translate-y-1 hover:shadow-print"
                >
                    <WhatsAppIcon className="h-5 w-5" />
                    Quale trattamento serve a te? Chiedilo su WhatsApp
                </a>
            </motion.div>
        </div>
    </section>
);
